import { useEffect, useRef } from 'react';

export default function SuccessMessage() {
  const headingRef = useRef(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className="thanks" role="status" aria-live="polite">
      <svg className="thanks__mark" viewBox="0 0 56 56" aria-hidden="true">
        <circle cx="28" cy="28" r="27" fill="var(--soft-green)" />
        <path
          d="M18 28.5l6.5 6.5L38.5 21"
          fill="none"
          stroke="var(--green)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h2 className="thanks__title" ref={headingRef} tabIndex={-1}>
        Thank you for registering
      </h2>
      <p className="thanks__text">We will keep you updated as our network reaches your area and when switching opens.</p>
    </div>
  );
}
